import { render, staticRenderFns } from "./TemposVitana.vue?vue&type=template&id=20ce7d40"
import script from "./TemposVitana.vue?vue&type=script&lang=js"
export * from "./TemposVitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports